import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import SaveIcon from '@mui/icons-material/Save';
import { StyledButton } from '../styles';

interface Props {
  handleSubmit: () => void;
}

const DialogHeader = ({ handleSubmit }: Props) => {
  return (
    <>
      <Grid item xs={10}>
        <Box display="flex" alignItems={'center'} px={8} pt={6}>
          <Typography
            variant="body1"
            id="modal-title"
            color="primary"
            style={{ fontSize: '1.25rem' }}
          >
            Configurar ordenamiento
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Box
          display="flex"
          justifyContent={'flex-end'}
          alignItems={'center'}
          px={6}
          pt={6}
        >
          <StyledButton
            color="primary"
            endIcon={<SaveIcon />}
            size={'small'}
            onClick={handleSubmit}
          >
            Aplicar
          </StyledButton>
        </Box>
      </Grid>
    </>
  );
};

export default DialogHeader;
